/**
 * Before & After Transformation section
 * Initializes every instance of the slider independently, so the
 * section can be added to a page multiple times without conflicts.
 */
(function () {
  function initSlider(root) {
    var afterPane = root.querySelector('[data-ta-after]');
    var divider = root.querySelector('[data-ta-divider]');
    var handle = root.querySelector('[data-ta-handle]');
    if (!afterPane || !divider || !handle) return;

    var dragging = false;

    function setPosition(pct) {
      pct = Math.min(98, Math.max(2, pct));
      afterPane.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      divider.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    function pctFromClientX(clientX) {
      var rect = root.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function startDrag() {
      dragging = true;
      document.body.style.userSelect = 'none';
    }
    function endDrag() {
      dragging = false;
      document.body.style.userSelect = '';
    }
    function moveHandler(e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(pctFromClientX(x));
    }

    handle.addEventListener('mousedown', startDrag);
    handle.addEventListener('touchstart', startDrag, { passive: true });
    window.addEventListener('mousemove', moveHandler);
    window.addEventListener('touchmove', moveHandler, { passive: true });
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchend', endDrag);

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ta-handle]')) return;
      setPosition(pctFromClientX(e.clientX));
    });

    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(divider.style.left) || 50;
      if (e.key === 'ArrowLeft') setPosition(current - 4);
      if (e.key === 'ArrowRight') setPosition(current + 4);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ta-slider]').forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Re-init when a section is added/re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector && e.target.querySelector('[data-ta-slider]');
    if (root) initSlider(root);
  });
})();
